import { updatesData } from '@/mocks/home';

const tagColors: Record<string, string> = {
  '新剧上线': 'bg-primary-100 text-primary-700',
  '高清修复': 'bg-accent-100 text-accent-700',
  '热门更新': 'bg-primary-100 text-primary-700',
  '即将上线': 'bg-secondary-100 text-secondary-700',
  '专题策划': 'bg-accent-100 text-accent-700',
  '追剧指南': 'bg-secondary-100 text-secondary-700',
  '口碑新剧': 'bg-primary-100 text-primary-700',
  '平台动态': 'bg-secondary-100 text-secondary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            追剧快讯
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            最新剧集动态和平台更新，不错过任何精彩内容
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-background-300/60">
            {updatesData.map((item, idx) => (
              <div key={item.id} className={`relative pb-8 ${idx === updatesData.length - 1 ? 'pb-0' : ''}`}>
                <div className="absolute -left-[25px] md:-left-[29px] top-0 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100"></div>
                <div className="flex flex-col md:flex-row md:items-start gap-2 md:gap-4">
                  <span className="text-xs font-medium text-foreground-500 whitespace-nowrap pt-0.5">
                    {item.date}
                  </span>
                  <div className="flex-1">
                    <p className="text-sm text-foreground-700 leading-relaxed mb-2">{item.content}</p>
                    <span
                      className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
                        tagColors[item.tag] || 'bg-secondary-100 text-secondary-700'
                      }`}
                    >
                      {item.tag}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}